module.exports = __webpack_public_path__ + "img/heart.c63ca602.svg";